import React from 'react'
import NumberFormat from 'react-number-format'

interface PhoneNumberInputProps {
  component: any
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

export const PhoneNumberInput = React.forwardRef<NumberFormat, PhoneNumberInputProps>(
  (props, ref) => {
    const { onChange, component, ...other } = props

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        type="tel"
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          })
        }}
        format="###-###-####"
      />
    )
  }
)
